module.exports = __webpack_public_path__ + "static/img/section_6_bg.2a64a00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.0/mobile/section_6_bg.png
// module id = Midh
// module chunks = 0